import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060129_01,
  },
  {
    keyword: "contractorAndNumber",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "職員氏名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "職員氏名（ｶﾅ）",
    keyword: "staffNameKana",
    type: "text",
  },
  {
    title: "QRコード",
    keyword: "qrCode",
    type: "nodeInLine",
  },
  {
    title: "URL",
    keyword: "URL",
    type: "text",
  },
  {
    title: "退職者識別コード",
    keyword: "transferCd",
    type: "text",
  },
];

export { fakeTableList };
